import type { ReactNode } from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button)(({ theme }) => ({
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  '&:hover': {
    backgroundColor: '#ddd',
    color: theme.palette.text.secondary,
  },
  '&:not(:hover)': {
    backgroundColor: '#eee',

    '&:not(.Mui-disabled)': {
      color: theme.palette.text.secondary,
    },
  },
})) as typeof Button;

export const LexicalBaseButton = ({
  'data-test-id': dataTestId,
  children,
  onClick,
  disabled,
}: {
  'data-test-id'?: string;
  children: ReactNode;
  // eslint-disable-next-line react/boolean-prop-naming
  disabled?: boolean;
  onClick: () => void;
}): JSX.Element => {
  return (
    <StyledButton disabled={disabled} onClick={onClick} {...(dataTestId && { 'data-test-id': dataTestId })}>
      {children}
    </StyledButton>
  );
};
